module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/noGamesIcons/noGames/mlb/survive_wt-c122b078cff4d72220a391be647712f7.svg";